/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { layers } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

const fileHeaderStackingIndex = layers.navigation() - 18;
const fileHeaderStackingIndexWhenActive = fileHeaderStackingIndex + 1;

export const StickyDiffHeader = styled.div<{
  isCommentNavOpen: boolean;
  isDiffSortOpen: boolean;
  isIterativeReviewSelectorOpen: boolean;
}>(({ isCommentNavOpen, isDiffSortOpen, isIterativeReviewSelectorOpen }) => ({
  backgroundColor: token('elevation.surface'),
  minHeight: token('space.500'),
  position: 'sticky',
  top: 'var(--pr-compact-header-bottom, 0)',

  zIndex:
    isCommentNavOpen || isDiffSortOpen || isIterativeReviewSelectorOpen
      ? `${fileHeaderStackingIndexWhenActive}`
      : `${fileHeaderStackingIndex}`,
}));
